import React from "react"
import { Helmet } from "react-helmet"

// TODO: dynamically build this array from the catalog
export function VulvaPreloader() {
  return (
    <Helmet>
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/layer/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/highlight/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/monspubis/thumbnail/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/layer/style-11.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/highlight/style-11.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/outer-labia/thumbnail/style-11.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-8.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-9.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-10.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-11.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-11.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-11.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/layer/style-12.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/highlight/style-12.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/inner-labia/thumbnail/style-12.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/urethra/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/urethra/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/urethra/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/layer/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/highlight/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/thumbnail/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/layer/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/highlight/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/thumbnail/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/layer/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/highlight/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/thumbnail/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/layer/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/highlight/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/thumbnail/style-5.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/layer/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/highlight/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/thumbnail/style-6.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/layer/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/highlight/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoris/thumbnail/style-7.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/layer/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/highlight/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/thumbnail/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/layer/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/highlight/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/clitoral-hoods/thumbnail/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/layer/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/highlight/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/thumbnail/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/layer/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/highlight/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/thumbnail/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/layer/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/highlight/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/piercings/thumbnail/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/layer/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/thumbnail/style-2.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/layer/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/thumbnail/style-3.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/layer/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/backgrounds/thumbnail/style-4.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/vagina/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/vagina/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/vagina/thumbnail/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/anus/layer/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/anus/highlight/style-1.svg"
        as="image"
      />
      <link
        rel="preload"
        href="/images/vulva-maker/anus/thumbnail/style-1.svg"
        as="image"
      />
    </Helmet>
  )
}
